import React, { Component } from 'react'

export default class Help extends Component {
    render() {
        return (
            <div>
                <h1>Help</h1>
            </div>
        )
    }
}
